import { asyncRouterMap, constantRouterMap } from '@/router'

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, roles) {
    const res = []
  
    routes.forEach(route => {
      const tmp = { ...route }
      if (hasPermission(roles, tmp)) {
        if (tmp.children) {
          tmp.children = filterAsyncRouter(tmp.children, roles)
        }
        res.push(tmp)
      }
    })
  
    return res
  }

  
const permission =  {
    state: {
        routers: [],
        addRouters: []
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers;
            state.routers = constantRouterMap.concat(routers)
        }
    },
    actions: {
        GenerateRoutes({commit}, data){
            return new Promise(resolve => {
                // console.log(data)
                const { roles } = data
                let accessedRouters
                if(true || roles.includes('admin')){
                    accessedRouters = asyncRouterMap;   
                }else{
                    accessedRouters = filterAsyncRouter(asyncRouterMap, roles);
                }
                commit("SET_ROUTERS", accessedRouters);
                resolve()
            })
        }
    }
}
export default permission;


// WEBPACK FOOTER //
// ./src/store/modules/permission.js